<div id="example2_wrapper" class="dataTables_wrapper dt-bootstrap4">
  @if (config?.topInputFilters?.length) {
    <div class="row mb-3">
      <div class="col-xxl-4 col-xl-6 col-12">
        <div class="d-flex flex-wrap gap-3">
          @for (filter of config?.topInputFilters; track filter) {
            <div class="flex-grow-1">
              @if (topInputControls[filter.attribute]) {
                <input-field
                  [label]="filter.label"
                  [type]="filter.type || 'text'"
                  [placeholder]="filter.placeholder"
                  [inputFormControl]="topInputControls[filter.attribute]"
                  />
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  <div class="row align-items-center mb-3">
    <div class="col-sm-12 col-md-6">
      <div class="dataTables_length">
        <label class="d-flex align-items-center">
          <span class="text-muted me-2">Show</span>
          <select [(ngModel)]="pageSize" (change)="changePageSize($event)" class="form-select form-select-sm"
            style="width: 4.25rem;">
            @for (opt of pageSizeOptions; track opt) {
              <option [ngValue]="opt">{{ opt }}</option>
            }
          </select>
          <span class="text-muted ms-2">results</span>
        </label>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 d-flex justify-content-end">
      @if (showExportButton) {
        <button
          class="btn btn-outline-primary"
          (click)="onExportExcel.emit()"
          [disabled]="isExporting">
          @if (isExporting) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          } @else {
            <i class="bi bi-file-earmark-spreadsheet me-1"></i>
          }
          Export Excel
        </button>
      }
    </div>
  </div>
  <div class="table-responsive">
    <table id="example2" class="table table-hover dataTable dtr-inline"
      aria-describedby="example2_info">
      <thead>
        <tr class="text-uppercase primary-header">
          @for (column of config?.columns; track column) {
            <th class="sorting resizer text-center"
              [class.not-sortable]="!isSortable(column)"
              (mousedown)="onResizeStart($event, column)"
              (click)="isSortable(column) && onSort(column.attribute)"
              [style.width]="column.width">
              <div class="d-flex justify-content-center align-items-center">
                <span>{{ column.header }}</span>
                @if (sortField === column.attribute) {
                  <span class="ms-1">
                    <i class="fa" [ngClass]="sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
                  </span>
                }
              </div>
            </th>
          }
        </tr>
        <tr class="filters-row">
          @for (column of config?.columns; track column) {
            <th class="filter-cell resizer"
              [style]="column.style">
              <div class="d-flex">
                @if (column.filter === 'text') {
                  <input type="text" class="form-control form-control-sm"
                    (input)="filter(column, $event)" placeholder="Search...">
                }
                @if (column.filter === 'date') {
                  <div class="d-flex w-100">
                    <input type="date" class="form-control form-control-sm"
                      (input)="checkDateFormat(column, $event)">
                  </div>
                }
                @if (column.filter === 'number-range') {
                  <div class="d-flex w-100 gap-1">
                    <input type="number" class="form-control form-control-sm"
                      (input)="filterRange(column, 'min', $event)" placeholder="Min">
                    <input type="number" class="form-control form-control-sm"
                      (input)="filterRange(column, 'max', $event)" placeholder="Max">
                  </div>
                }
                @if (column.filter === 'select' && column.filterOptionsSource) {
                  <select
                    class="form-select form-select-sm custom-select-arrow"
                    [value]="currentFilterValues[column.attribute] ?? ''"
                    (change)="filter(column, $event)">
                    <option [value]="''">All</option>
                    @for (option of dynamicOptions[column.attribute]; track option) {
                      <option [value]="option.key" [selected]="isSelectedFilterOption(column, option.key)">{{
                      option.value }}</option>
                    }
                  </select>
                }
                @if (column.filter === 'select' && !column.filterOptionsSource) {
                  <select
                    class="form-select form-select-sm custom-select-arrow"
                    (change)="filter(column, $event)">
                    <option [value]="''">All</option>
                    @for (option of getUniqueOptions(column); track option) {
                      <option [value]="option">{{ option }}
                      </option>
                    }
                  </select>
                }
                @if (column.filter === 'autocomplete') {
                  <div class="autocomplete-container">
                    <input type="text" class="form-control form-control-sm" (input)="filter(column, $event)"
                      placeholder="Search...">
                    @if (autocompleteOptions[column.attribute]?.length) {
                      <ul class="autocomplete-options">
                        @for (option of autocompleteOptions[column.attribute]; track option) {
                          <li
                          (click)="selectAutocompleteOption(column, option)">{{ option }}</li>
                        }
                      </ul>
                    }
                  </div>
                }
                @if (column.filter === 'multiselect') {
                  <div class="multiselect-container">
                    <button type="button" class="form-select form-select-sm custom-select-arrow multiselect-toggle"
                      (click)="toggleMultiSelectDropdown(column, $event); $event.stopPropagation()">
                      {{ getMultiSelectLabel(column) }}
                    </button>
                    @if (multiSelectOpenColumn === column.attribute) {
                      <ul class="multiselect-options" [ngStyle]="multiSelectDropdownStyle" (click)="$event.stopPropagation()">
                        @for (option of dynamicOptions[column.attribute]; track option.key) {
                          <li>
                            <label class="d-flex align-items-center gap-2 mb-0">
                              <input type="checkbox"
                                [checked]="isMultiSelectOptionChecked(column, option.key)"
                                (change)="onMultiSelectOptionToggle(column, option.key, $event)">
                              {{ option.value }}
                            </label>
                          </li>
                        }
                      </ul>
                    }
                  </div>
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (item of config?.data; track item; let i = $index) {
          <tr
            class="{{ isEven(i) ? 'even' : 'odd' }}"
            [ngClass]="{'in-evidence': config?.inEvidence && config?.inEvidence(item)}">
            @for (column of config?.columns; track column) {
              <td class="dtr-control resizer" tabindex="0" [ngClass]="column.cellClass ?? ''">
                @if (isDataTableColumnText(column)) {
                  <data-table-column-text [item]="item" [column]="asDataTableColumnText(column)"
                    />
                }
                @if (isDataTableColumnIcons(column)) {
                  <data-table-column-icon [item]="item" [column]="asDataTableColumnIcons(column)"
                    />
                }
                @if (isDataTableColumnWaitingTime(column)) {
                  <data-table-column-waiting-time [item]="item"
                    [column]="asDataTableColumnWaitingTime(column)"
                    />
                }
                @if (isDataTableColumnBadge(column)) {
                  <data-table-column-badge [item]="item" [column]="asDataTableColumnBadge(column)" />
                }
                @if (isDataTableColumnLink(column)) {
                  <data-table-column-link [item]="item" [column]="asDataTableColumnLink(column)" />
                }
                @if (isDataTableColumnActions(column)) {
                  <data-table-column-actions [item]="item" [column]="getVisibleActionsColumn(asDataTableColumnActions(column))"
                    (deleteClicked)="confirmDelete($event)" />
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (config && config!.pagination) {
    <div class="row justify-content-between align-items-center mt-3">
      <div class="col-sm-12 col-md-5">
        @if (config.pagination.totalCount > 0) {
          <div class="text-muted small">
            Showing <strong>{{ config.pagination.page * config.pagination.pageSize + 1 }}</strong> to
            <strong>{{ Math.min((config.pagination.page + 1) * config.pagination.pageSize, config.pagination.totalCount) }}</strong>
            of <strong>{{ config.pagination.totalCount }}</strong> entries
          </div>
        }
      </div>
      <div class="col-sm-12 col-md-7">
        <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
          <ul class="pagination pagination-sm justify-content-end mb-0 primary-pagination">
            <li class="paginate_button page-item previous" [ngClass]="{ 'disabled': currentPage === 0 }"
              id="example2_previous">
              <a aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link"
              (click)="changePage(currentPage - 1)">Back</a>
            </li>
            @if (!shouldUseCompactPagination()) {
              @for (page of getAllPages(); track page) {
                <li class="paginate_button page-item"
                  [ngClass]="{ 'active': page === currentPage }">
                  <a aria-controls="example2" tabindex="0" class="page-link" (click)="changePage(page)">{{ page + 1 }}</a>
                </li>
              }
            }
            @if (shouldUseCompactPagination()) {
              <li class="paginate_button page-item" [ngClass]="{ 'active': currentPage === 0 }">
                <a aria-controls="example2" tabindex="0" class="page-link" (click)="changePage(0)">1</a>
              </li>
              @if (getVisiblePages().length > 0 && getVisiblePages()[0] > 1) {
                <li class="paginate_button page-item disabled">
                  <a aria-controls="example2" tabindex="-1" class="page-link">...</a>
                </li>
              }
              @for (page of getVisiblePages(); track page) {
                <li class="paginate_button page-item"
                  [ngClass]="{ 'active': page === currentPage }">
                  <a aria-controls="example2" tabindex="0" class="page-link" (click)="changePage(page)">{{ page + 1 }}</a>
                </li>
              }
              @if (getVisiblePages().length > 0 && getVisiblePages()[getVisiblePages().length - 1] < config!.pagination.totalPages - 2) {
                <li
                  class="paginate_button page-item disabled">
                  <a aria-controls="example2" tabindex="-1" class="page-link">...</a>
                </li>
              }
              @if (config!.pagination.totalPages > 1) {
                <li
                  class="paginate_button page-item" [ngClass]="{ 'active': currentPage === config!.pagination.totalPages - 1 }">
                  <a aria-controls="example2" tabindex="0" class="page-link"
                  (click)="changePage(config!.pagination.totalPages - 1)">{{ config!.pagination.totalPages }}</a>
                </li>
              }
            }
            <li class="paginate_button page-item next"
              [ngClass]="{ 'disabled': currentPage === config!.pagination.totalPages - 1 }"
              id="example2_next">
              <a aria-controls="example2" tabindex="0" class="page-link"
              (click)="changePage(currentPage + 1)">Forward</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  }
</div>